'use strict';
var throttle = require('lodash/throttle');

/**
 * Show sticky panel
 * @param {Object} obj - target sticky panel
 */
function enableSticky(obj) {
    $(obj).addClass('m-active');
};
/**
 * Hide sticky panel
 * @param {Object} obj - target sticky panel
 */
function disableSticky(obj) {
    $(obj).removeClass('m-active');
}

/**
 * Report sticky display to dataLayer
 * @param {Object} data - sticky object stickySettings attribute is passed in here.
 */
function reportSticky(data) {
    window.dataLayer = window.dataLayer || [];
    if (data && data.stickyElement) {
        window.dataLayer.push({
            event: 'sticky_element_display',
            stickyElement: data.stickyElement,
            pdpSku: data.stickyDetail
        });
    }
}
/**
 * Throttle calculation for sticky object after scroll event
 * @param {Object} stickyObj - target sticky panel
 */
var scrollThrottle = throttle(function (stickyObj) {
    var windowScroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var $stickyObj = $(stickyObj);
    var data = $stickyObj.data('stickySettings');
    var $enabledStickyObj = $(data.stickyEnable);
    if ($enabledStickyObj.length) {
        var objOffsetTop = $enabledStickyObj.offset().top;
    }
    var stickyHeight = $stickyObj.outerHeight();
    if (document.documentElement.clientWidth >= 768) {
        if (windowScroll > 120) {
            if (
                (windowHeight + windowScroll) < objOffsetTop ||
                (windowScroll - stickyHeight) > objOffsetTop &&
                !$stickyObj.is('.m-active')
            ) {
                enableSticky($stickyObj);
                reportSticky(data);
            } else if (
                (windowScroll < objOffsetTop) &&
                $stickyObj.is('.m-active')
            ) {
                disableSticky($stickyObj);
            }
        } else {
            disableSticky(stickyObj);
        }
    } else {
        var isMobile = true;
        if (
            (windowHeight + windowScroll) < objOffsetTop ||
            (windowScroll - stickyHeight) > objOffsetTop &&
            !$stickyObj.is('.m-active')
        ) {
            enableSticky($stickyObj);
            reportSticky(data);
        } else if (
            (windowScroll < objOffsetTop) &&
                $stickyObj.is('.m-active')
        ) {
            disableSticky($stickyObj);
        }
    }
}, 500);

module.exports = {
    stickyInit: function () {
        $(window).on('scroll', function () {
            $('.js-sticky').each(function (ind, stickyObj) {
                scrollThrottle(stickyObj);
            });
        });
    },
    enableSticky: enableSticky,
    disableSticky: disableSticky
};
